import {Component, OnInit} from '@angular/core';
import {DarkModeService} from "../../../core/services/dark-mode.service";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    standalone: false
})
export class HeaderComponent implements OnInit {

  isDarkModeEnabled = false;

  constructor(private darkModeService: DarkModeService) {
  }

  ngOnInit(): void {
    // Load initial value from the service
    this.isDarkModeEnabled = this.darkModeService.isDarkModeEnabled();
    this.updateDarkModeClass();
  }

  enableDarkMode(): void {
    this.isDarkModeEnabled = true;
    this.darkModeService.enableDarkMode()
    this.updateDarkModeClass();
  }

  disableDarkMode(): void {
    this.isDarkModeEnabled = false;
    this.darkModeService.disableDarkMode();
    this.updateDarkModeClass();
  }

  private updateDarkModeClass(): void {
    const rootElement = document.documentElement;
    if (this.isDarkModeEnabled) {
      rootElement.classList.add('dark');
    } else {
      rootElement.classList.remove('dark');
    }
  }
}
